import { withGlobal } from "components/global/GlobalWrapper";
import { InvoicePage } from "./InvoicePage";
import { residentPaymentsReducers } from "components/stores/resident_payments/reducers";

export default withGlobal(InvoicePage, { reducers: residentPaymentsReducers })
